<!-- 基准积分标准 -->
<template>
  <div class="rules global-content-flex">
    <div class="global-felx">
      <div class="head_rules">
      <y-button @click="showDialog(1)">积分获取上限</y-button>
      <y-button @click="showDialog(2)"
        >积分发放时间设置</y-button
      >
      </div>
      <div class="main_content">
        <div class="inline_item">
          <div class="inline-label"><span class="red">*</span>基础积分:</div>
          <div class="inline-form" style="margin-top: -5px">
            <div>
              订单实付金额（不含邮费），每
              <el-input
                v-model="form.baseMoney"
                v-numHave2Decimal
                @blur="handleMoney"
                class="inline_input"
                placeholder="请输入"
              ></el-input
              >元送
              <el-input
                v-model="form.baseScores"
                v-numNoZero
                v-numOnly
                class="inline_input"
                placeholder="请输入"
              ></el-input
              >积分
            </div>
          </div>
        </div>
        <div class="inline_item">
          <div class="inline-label">等级差异积分:</div>
          <div class="inline-form">
            <div class="tips">
              等级差异积分=基础积分 x 等级差异倍数
              （注：基于订单实付金额计算积分，若出现小数，则向下取整发放）
            </div>
            <div
              class="level_item"
              v-for="(item, index) in gradeList"
              :key="item.gradeCode"
            >
              <div class="level_title">{{ item.gradeName }}</div>
              <el-input
                v-model="form['vip' + (index + 1)]"
                v-numHave2Decimal
                @blur="handleMoney"
                class="level_input"
                placeholder="请输入"
              ></el-input
              >倍
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="global-bottom-btn">
      <y-button type="blue" @click="handleSave">保存</y-button>
    </div>
    <y-dialog
      title="积分上限设置"
      :visible.sync="upperLimitShow"
      width="750px"
      :before-close="resetForm"
      append-to-body
      sureText="保存"
      @comfirm="upperLimitDialogConfirm(1)"
      @close="dialogClose()"
    >
      <y-tip>
        <div class="tips_line">
          1、积分限制仅针对订单来源积分有效（包含奖励积分）排除退款扣的积分。
        </div>
        <div class="tips_line">
          2、积分即将到上限时，最后一笔订单给予积分最多到上限值。
        </div>
        <div class="tips_line">3、限制时间：自然日，自然周，自然月。</div>
        <div class="tips_line">
          4、若有一个条件（日、周、月）满足（已达限制）将不再赠送积分。
        </div>
      </y-tip>
      <div class="inline_item" style="margin-top: 20px">
        <div class="inline-label" style="width: 70px">限制时间：</div>
        <div class="inline-form" style="margin-left: 10px">
          <el-checkbox
            v-model="form.isDayLimit"
            :true-label="1"
            :false-label="0"
            @change="limitChange"
            >每日限制</el-checkbox
          >
          <el-checkbox
            v-model="form.isWeekLimit"
            :true-label="1"
            :false-label="0"
            @change="limitChange"
            >每周限制</el-checkbox
          >
          <el-checkbox
            v-model="form.isMonthLimit"
            :true-label="1"
            :false-label="0"
            @change="limitChange"
            >每月限制</el-checkbox
          >
          <div class="level_item" v-if="form.isDayLimit">
            当天积分值达到<el-input
              class="inline_input"
              v-numOnly
              v-numeric-only
              v-model="form.dayLimitScores"
              placeholder="请输入"
            ></el-input
            >积分，限制发放
          </div>
          <div class="level_item" v-if="form.isWeekLimit">
            当周积分值达到<el-input
              class="inline_input"
              v-numOnly
              v-numeric-only
              v-model="form.weekLimitScores"
              placeholder="请输入"
            ></el-input
            >积分，限制发放
          </div>
          <div class="level_item" v-if="form.isMonthLimit">
            当月积分值达到<el-input
              class="inline_input"
              v-numOnly
              v-numeric-only
              v-model="form.monthLimitScores"
              placeholder="请输入"
            ></el-input
            >积分，限制发放
          </div>
        </div>
      </div>
    </y-dialog>
    <y-dialog
      title="积分发放时间设置"
      :visible.sync="pointsTimeShow"
      width="750px"
      :before-close="resetForm"
      append-to-body
      sureText="保存"
      @comfirm="upperLimitDialogConfirm(0)"
      @close="dialogClose()"
    >
      <y-tip>
        <div class="tips_line">
          1.确认收货后立即发放：线上订单为确认收货后立即发放；线下订单为交易完成后立即发放。
        </div>
        <div class="tips_line">
          2.确认发货后延迟发放：线上订单为确认收货X天后发放积分；线下订单为交易完成X天后发放积分
        </div>
      </y-tip>
      <div>
        <div style="margin: 25px 0px">
          <el-radio v-model="form.scoresEffectiveRules" :label="1"
            >确认收货后立即发放</el-radio
          >
        </div>
        <div style="margin-bottom: 40px">
          <el-radio v-model="form.scoresEffectiveRules" :label="2">
            确认收货后延迟发放
            <span style="margin-left: 40px"
              >确认收货<el-input
                class="inline_input"
                v-model="form.confirmDay"
                v-numOnly
                v-numNoZero
                placeholder="请输入"
              ></el-input
              >天后，发放积分</span
            >
          </el-radio>
        </div>
      </div>
    </y-dialog>
    <y-dialog
      title="提示"
      :visible.sync="sureDialogVisible"
      width="452px"
      top="40vh"
      @comfirm="submitBtn"
      @close="sureDialogVisible = false"
    >
      <y-tip type="gley-empty">
        <span
          >积分规则修改确认后，新增订单将按照最新的积分规则计算积分，请尽快同步买家端积分规则说明。</span
        >
      </y-tip>
    </y-dialog>
  </div>
</template>

<script>
import {
  benchmarkDetail,
  benchmarkUpdate,
  getDetailById,
} from "@/api/integralCenter/newMemberSystem";
export default {
  data() {
    return {
      MemberSystemInfo: {},
      gradeList: [],
      form: {
        baseMoney: "", // 消费金额
        baseScores: "", // 赠送积分
        vip1: "",
        vip2: "",
        vip3: "",
        vip4: "",
        vip5: "",
        vip6: "",
        vip7: "",
        isDayLimit: 0, // 是否每日限制
        dayLimitScores: "",
        isWeekLimit: 0, // 是否每周限制
        weekLimitScores: "",
        isMonthLimit: 0, // 是否每月限制
        monthLimitScores: "",
        scoresEffectiveRules: 1, // 积分发放时间
        confirmDay: "", // 确认收货后天数
      },
      upperLimitShow: false, // 积分上限弹窗
      pointsTimeShow: false, // 积分发放时间弹窗
      sureDialogVisible: false,
      dForm: {},
    };
  },
  computed: {},
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    this.getInfo();
    // 拷贝一份弹窗初始数据
    this.dForm = { ...this.form };
  },
  methods: {
    // 获取基准积分规则
    getInfo() {
      getDetailById({ cardId: this.MemberSystemInfo.scoresCardId }).then(
        (res) => {
          this.gradeList = res.data.gradeList.length
            ? res.data.gradeList
            : [{ gradeName: "店铺客户", gradeCode: 1 }];
          benchmarkDetail({ cardId: this.MemberSystemInfo.scoresCardId }).then(
            (res) => {
              if (JSON.stringify(res.data) != "{}") {
                // this.form = res.data
                this.form.baseMoney = res.data.baseMoney || "";
                this.form.baseScores = res.data.baseScores || "";
                this.form.vip1 = res.data.vip1 || "";
                this.form.vip2 = res.data.vip2 || "";
                this.form.vip3 = res.data.vip3 || "";
                this.form.vip4 = res.data.vip4 || "";
                this.form.vip5 = res.data.vip5 || "";
                this.form.vip6 = res.data.vip6 || "";
                this.form.vip7 = res.data.vip7 || "";
                this.form.dayLimitScores = res.data.dayLimitScores || "";
                this.form.weekLimitScores = res.data.weekLimitScores || "";
                this.form.monthLimitScores = res.data.monthLimitScores || "";
                this.form.isDayLimit = res.data.isDayLimit || 0;
                this.form.isWeekLimit = res.data.isWeekLimit || 0;
                this.form.isMonthLimit = res.data.isMonthLimit || 0;
                this.form.scoresEffectiveRules =
                  res.data.scoresEffectiveRules || 1;
                this.form.confirmDay = res.data.confirmDay || "";
                this.form.scoresCardRuleId = res.data.scoresCardRuleId || "";
                console.log(this.form);
                this.dForm = { ...this.form };
              }
            }
          );
        }
      );
    },
    // 保存按钮
    handleSave() {
      if (!this.form.baseMoney || !this.form.baseScores) {
        return this.$message.warning("请填写基础积分");
      }
      console.log(this.form, "=====>保存数据");

      console.log(this.form);
      this.sureDialogVisible = true;
    },
    // 确认保存
    submitBtn() {
      let obj = {
        ...this.form,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
      };
      this.sureDialogVisible = false;
      benchmarkUpdate(obj).then((res) => {
        if (res.code == 200) {
          this.$message.success("保存成功");
        }
      });
    },
    // 未勾选清空输入框
    limitChange() {
      if (this.form.isDayLimit == 0) {
        this.form.dayLimitScores = "";
      } else if (this.form.isWeekLimit == 0) {
        this.form.weekLimitScores = "";
      } else if (this.form.isMonthLimit == 0) {
        this.form.monthLimitScores = "";
      }
    },
    // 积分上限保存
    upperLimitDialogConfirm(val) {
      if (val) {
        // 积分获取上限
        console.log(this.form);
        if (this.form.isDayLimit == 1) {
          if (this.form.dayLimitScores === "")
            return this.$message.warning("请输入每日限制积分");
          if (this.form.dayLimitScores == 0)
            return this.$message.warning("每日限制积分不能为0");
        } else if (this.form.isWeekLimit == 1) {
          if (this.form.weekLimitScores === "")
            return this.$message.warning("请输入每周限制积分");
          if (this.form.weekLimitScores == 0)
            return this.$message.warning("每周限制积分不能为0");
        } else if (this.form.isMonthLimit == 1) {
          if (this.form.monthLimitScores === "")
            return this.$message.warning("请输入每月限制积分");
          if (this.form.monthLimitScores == 0)
            return this.$message.warning("每月限制积分不能为0");
        }
        this.upperLimitShow = false;
        this.dForm = { ...this.form };
      } else {
        // 积分发放时间设置
        if (this.form.scoresEffectiveRules == 2 && !this.form.confirmDay) {
          return this.$message.warning("请输入延迟发放天数");
        }
        this.pointsTimeShow = false;
        this.dForm = { ...this.form };
      }
      console.log(this.dForm);
    },
    // 关闭弹窗
    dialogClose() {
      // 弹窗数据回显(未保存回显上一次保存的数据)
      this.form = {
        ...this.form,
        isDayLimit: this.dForm.isDayLimit || 0,
        dayLimitScores: this.dForm.dayLimitScores,
        isWeekLimit: this.dForm.isWeekLimit || 0,
        weekLimitScores: this.dForm.weekLimitScores,
        isMonthLimit: this.dForm.isMonthLimit || 0,
        monthLimitScores: this.dForm.monthLimitScores,
        scoresEffectiveRules: this.dForm.scoresEffectiveRules,
        confirmDay: this.dForm.confirmDay,
      };
      // console.log(this.dForm);
      this.upperLimitShow = false;
      this.pointsTimeShow = false;
    },
    // 打开积分上限/积分发放时间弹窗
    showDialog(type) {
      // 弹窗回显已保存的内容
      if (type == 1) {
        this.upperLimitShow = true;
      } else {
        this.pointsTimeShow = true;
      }
    },
    resetForm() {
      this.dialogClose();
    },
    handleMoney(event) {
      if (Number(event.target.value) == Number(0)) {
        event.target.value = "0.01";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rules {
  height: 100%;
}

.inline_input {
  width: 100px;
  margin: 0 8px;
}

.main_content {
  margin-top: 20px;
}

.inline_item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 28px;
  font-size: 12px;
  .inline-label {
    width: 76px;
    text-align: right;
    color: $text-6;
  }

  .inline-form {
    margin-left: 15px;

    .tips {
      // color: #686565;
    }

    .level_item {
      margin-top: 16px;
      font-size: 12px;

      .level_title {
        display: inline-block;
        width: 90px;
        text-align: left;
        word-break: break-all;
        word-wrap: break-word;
      }
    }

    .level_input {
      width: 150px;
      margin: 0px 8px 0px 8px;
    }
  }
}

.red {
  color: red;
  margin-right: 1px;
}
</style>